
import { brandColors as colors } from "@/lib/palette";
import Footer from "@/components/ui/Footer";
import ChelseaIntroSection from "@/components/sections/ChelseaIntroSection";

export default function AboutPage() {
  return (
    <div className="min-h-dvh" style={{ backgroundColor: colors.cream }}>
      <ChelseaIntroSection />
      <Footer />
    </div>
  );
}
